import { makeStyles } from "tss-react/mui"
import { Accordion, AccordionDetails, AccordionSummary, Alert, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    faExclamationCircle,
    faInfoCircle,
    faExclamationTriangle,
    faCheckCircle,
} from "@fortawesome/pro-regular-svg-icons"
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material"
import { DeviceTypeReportStatus } from "../../../modules/merchant/merchant/home/merchantHomeTypes"

const useStyles = makeStyles()((theme) => ({
    alert: {
        width: "100%",
        padding: theme.spacing(2),
        borderRadius: "0.5rem",
        "& .MuiAlert-message": {
            width: "100%",
            overflow: "hidden",
        },
    },
    accordion: {
        background: "transparent",
        boxShadow: "none",
        width: "100%",
    },
    accordionSummary: {
        padding: 0,
        minHeight: "auto",

        "&.Mui-expanded": {
            minHeight: "auto",
        },
        "& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
        },
    },
    accordionDetails: {
        padding: theme.spacing(2),
        paddingLeft: 0,
    },
    accordionText: {
        paddingTop: "0.25rem",
    },
}))
type AlertAccordionProps = {
    status: DeviceTypeReportStatus
    title: string
    message: string
    children: React.ReactNode
}

export const getSeverityIcon = (status: DeviceTypeReportStatus) => {
    switch (status) {
        case DeviceTypeReportStatus.ALERT:
            return <FontAwesomeIcon icon={faExclamationCircle} size="lg" style={{ color: "#E53E3E" }} />
        case DeviceTypeReportStatus.WARNING:
            return <FontAwesomeIcon icon={faExclamationTriangle} size="lg" style={{ color: "#F6AD55" }} />
        case DeviceTypeReportStatus.INFO:
            return <FontAwesomeIcon icon={faInfoCircle} size="lg" style={{ color: "#3182CE" }} />
        case DeviceTypeReportStatus.SUCCESS:
            return <FontAwesomeIcon icon={faCheckCircle} size="lg" style={{ color: "#38A169" }} />
        default:
            return <FontAwesomeIcon icon={faExclamationCircle} size="lg" style={{ color: "#E53E3E" }} />
    }
}

export const DeviceReportAlertAccordion: React.FC<AlertAccordionProps> = ({ status, title, message, children }) => {
    const { classes } = useStyles()

    function getAlertSeverity(status: DeviceTypeReportStatus) {
        switch (status) {
            case DeviceTypeReportStatus.ALERT:
                return "error"
            case DeviceTypeReportStatus.WARNING:
                return "warning"
            case DeviceTypeReportStatus.INFO:
                return "info"
            case DeviceTypeReportStatus.SUCCESS:
                return "success"
            default:
                return "error"
        }
    }

    return (
        <Alert severity={getAlertSeverity(status)} className={classes.alert}>
            <Accordion className={classes.accordion}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                    <Typography fontWeight="bold" color={getAlertSeverity(status)}>
                        {title}
                    </Typography>
                </AccordionSummary>
                <Typography color={getAlertSeverity(status)} className={classes.accordionText}>
                    {message}
                </Typography>
                <AccordionDetails className={classes.accordionDetails}>{children}</AccordionDetails>
            </Accordion>
        </Alert>
    )
}
